// EVENT MATERIALS
(function () {
	// Main Wrapper
	const wrapper = document.querySelector('.event__event-materials');

  if (!wrapper) return;

	// Filter forms
	const filtersForm = document.getElementById('filters-form');
	// Container
	const container = document.getElementById('event-materials__container');
	// Page
	const pageInput = filtersForm.querySelector('input[name="page"]');
	// Checkboxes for Years
  const postTypesCheckBoxes = filtersForm.querySelectorAll('input[name="post_type"]');
	// Post IDs
  const postIDs = filtersForm.querySelector('input[name="post-ids"]');

	// Element to update with the results number after sending request
	const resultsNumber = wrapper.querySelector('.js-results-number');
	
	if (!pageInput) {
		console.error(`Page input wasnt't found, this field is mandatory for the filters & pagination to work`);
		return;
	}

	// Disable default submit for the form
	filtersForm.addEventListener('submit', e => {
		e.preventDefault();
	});

	// On filtering post types
  postTypesCheckBoxes?.forEach((postType) => {
    postType.addEventListener('change', e => handleFilterChange(e));
  });

  async function handleFilterChange(e) {
		// Reset page back to page 1 when applying any type of filter
		pageInput.value = '1';

    const postType = e.target.getAttribute('data-name');

		// Load posts
		await loadPosts(postType);
	}


	// FUNCTION TO HANDLE FILTER CHANGE
  async function loadPosts(postType) {

    container.classList.add('loading');

    const thePostIDs = postIDs.value;
    const formData = new FormData();

    formData.append('post_type', postType);
    formData.append('post_ids', thePostIDs);
    formData.append('page', pageInput.value);

    // Append action & nonce parameters
    formData.append('action', 'event_materials');
    formData.append('nonce', ajax_params.nonce);

    try {
      const response = await fetch(ajax_params.ajax_url, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const { success, data } = await response.json();
        const { resultsCount, content } = data;

        container.innerHTML = content;

        if (resultsNumber) {
          resultsNumber.innerHTML = `${(resultsCount === 1 ? 'Event Material' : 'Event Materials')} <span>${resultsCount}</span>`;
        }

      } else {
        console.error('Error:', response.status);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      container.classList.remove('loading');
    }
  }

  // Helper function to scroll on the start of archive when applying filter
	function scrollToStart() {
		const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--app-header-height') || '93px';

		const { top } = container.getBoundingClientRect();

		const topPosition = top + window.scrollY - parseInt(headerHeight, 10) - 100;

		scrollTo({
			top: topPosition,
			behavior: "smooth"
		});
	}

  // PAGINATION
	wrapper.addEventListener('click', async (e) => {

		// Pagination
		if (e.target.closest('.pagination-button')) {
			e.preventDefault();

			const paginationButton = e.target.closest('.pagination-button');

			if (paginationButton.disabled) return;

			targetPage = paginationButton.getAttribute('data-page');
			if (!targetPage) {
				console.warn('Pagination Error, targetPage not found');
				return;
			}

			// Update page input
			pageInput.value = targetPage;

      let postType;

      postTypesCheckBoxes.forEach((checkBox) => {
        if (checkBox.checked) {
          postType = checkBox.getAttribute('data-name');
        }
      });

			// Load posts
			await loadPosts(postType);

			// Scroll back at the start of the archive
			scrollToStart();
		}

	});

})();